import { RESET_VALIDATION_ERROR, SET_VALIDATION_ERROR } from "../actionTypes";

function setValidationErrors(errors) {
    return {
        type: SET_VALIDATION_ERROR,
        errors
    }
}

function resetValidationErrors() {
    return { type: RESET_VALIDATION_ERROR }
}

export const errorActions = { setValidationErrors, resetValidationErrors }